import http from '@/utils/http'

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return http.get('/system/dict/data/type/' + dictType)
}

// 获取微信认证
export function getWxAuth(params) {
    return http.get('/oauth/server-exam/registeredClient/getwxjsSing', params)
}

// 获取视频文件播放签名
export function getVideoPlaySign(fileId) {
    return http.get(`/vod/server-vod/vod/layerSign?fileId=${fileId}`)
}

// 获取小程序 加密  URL Scheme
export function getSchemeCode(params) {
    return http.get('/oauth/server-exam/registeredClient/getSchemeCode', params)
}